import { colorCategories } from './types';

export const WebSocketURL =
  process.env.REACT_APP_ENV === 'staging'
    ? 'wss://ws.optitrac.com/steelserv-staging?application='
    : 'wss://ws.optitrac.com/steelserv-production?application=';

export enum SocketRoom {
  SCRAP_BINS = 'scrap_bins',
  ENGINE_HOURS = 'engine_hours',
  WATER_CARTS = 'water_carts',
}

export enum SocketClient {
  ADMIN = 'admin',
}

export type EngineHoursSocketData = {
  engineStatus: EngineEvent;
  truckName: string;
  engineHours?: {
    truckName: string;
    deviceId: string;
    calculatedEngineHours: number;
    calculatedEngineMinutes: number;
    totalEngineHoursInMinutes: number;
    currentEngineStatus: EngineEvent;
    lastUpdatedTime?: Date;
  };
};

export enum EngineEvent {
  ON = 'ON',
  OFF = 'OFF',
}

export const truckCategoryColors: { [key: number]: string } = {
  8: '#2256E4', // Excavator
  7: '#8FC4FF', // Loader
  1: '#B9DBFF', // Water Truck
  11: '#E5F2FF', // Dump Truck
  4: '#FFB400', // Bin Truck
  5: '#FF9300', // Sludge Truck
  10: '#FF3B2B', // Ultes
  3: '#000000', // Gascavator
  0: '#FF9388', // Misc
};

export const TruckColors: { [key: number]: string } = {
  0: '#caf0f8',
  1: '#ade8f4',
  2: '#0077b6',
  3: '#0096c7',
  4: '#00b4d8',
  5: '#48cae4',
  6: '#90e0ef',
  7: '#023e8a',
  8: '#03045e',
  9: '#0077b6',
  10: '#023e8a',
  11: '#03045e',
  12: '#00b4d8',
  13: '#48cae4',
  14: '#90e0ef',
  15: '#ade8f4',
  16: '#caf0f8',
  17: '#0077b6',
  18: '#023e8a',
  19: '#03045e',
};

export const SpeedEventColors = {
  30: '#FEC404',
  40: '#FBA44E',
  50: '#FF6124',
};
export const FleetActivityColors = {
  0: '#85D813',
  1: '#4392F7',
  2: '#C2C0B9',
};
export const MaterialDumpingCycleColors = {
  1: '#FF8B30',
  2: '#FFC440',
  3: '#FFDB41',
  4: '#CECECE',
};
export const MaterialColors = [
  { start: '#0F63EF', stop: '#7B9BFC' },
  { start: '#3585FF', stop: '#549EFF' },
  { start: '#80B6FF', stop: '#C7E0FF' },
  { start: '#84A6FD', stop: '#C5D4FA' },
  { start: '#A6AAC1', stop: '#A6AAC1' },
  { start: '#00276A', stop: '#B4C6FF' },
  { start: '#002E7B', stop: '#4664BE' },
  { start: '#000815', stop: '#505D84' },
  { start: '#0098E8', stop: '#C7E5FF' },
  { start: '#80D3FF', stop: '#C7E5FF' },
];
export const BinPickJobColors = {
  1: '#FF8B30',
  2: '#9FCFFF',
};

export const preStartChecksColors = {
  0: '#85D813',
  1: '#FF5341',
  2: '#EBEBEB',
};
export const ShiftLoaderColors = {
  0: '#FF5341', // StoppedTime
  1: '#85D813', // Runtime
};

export const zoneColors = {
  1: '#004CDE',
  2: '#559FFF',
  3: '#C3DCFF',
  4: '#69CBFF',
  5: '#00A8FF',
  6: '#003D91',
  Outside: '#000000',
};

export const TowerColors = {
  'Tower 1': '#C3D3FF',
  'Tower 2': '#FFD947',
  Unkonwn: '#D2D1D8',
};

export const defaultZones = [
  {
    zone: '1',
    totalWaterConsumption: 0,
    color: zoneColors?.['1'] || undefined,
  },
  {
    zone: '2',
    totalWaterConsumption: 0,
    color: zoneColors?.['2'] || undefined,
  },
  {
    zone: '3',
    totalWaterConsumption: 0,
    color: zoneColors?.['3'] || undefined,
  },
  {
    zone: '4',
    totalWaterConsumption: 0,
    color: zoneColors?.['4'] || undefined,
  },
  {
    zone: '5',
    totalWaterConsumption: 0,
    color: zoneColors?.['5'] || undefined,
  },
  {
    zone: '6',
    totalWaterConsumption: 0,
    color: zoneColors?.['6'] || undefined,
  },
  {
    zone: 'Outside',
    totalWaterConsumption: 0,
    color: zoneColors?.['Outside'] || undefined,
  },
];
